import DiaryCalendar from '../../components/DiaryCalendar';
import { useApplication } from '../ApplicationState';
export default function CalendarOverlay() {
  const { showCalendar, setShowCalendar } = useApplication();
  return (
    <>
      {/* ===== 日历弹窗 ===== */}
      {showCalendar && (
        <div
          className="cal-overlay"
          onClick={(e) => e.target === e.currentTarget && setShowCalendar(false)}
        >
          <div className="cal-modal">
            <DiaryCalendar />
          </div>
        </div>
      )}
    </>
  );
}
